// extracted by mini-css-extract-plugin
export var cardContainer = "richtextServiceCard-module--card-container--4de02";
export var cardContent = "richtextServiceCard-module--card-content--e1d9b";
export var cardImg = "richtextServiceCard-module--card-img--e93c2";
export var cardTitle = "richtextServiceCard-module--card-title--f0a90";
export var centerAlignedContainer = "richtextServiceCard-module--center-aligned-container--9c02b";
export var emptyDiv = "richtextServiceCard-module--emptyDiv--f4248";
export var sectionCardTitle = "richtextServiceCard-module--section-card-title--54275";